export const autoLabel = (key) => {
    return key
      .replace(/([a-z])([A-Z])/g, '$1 $2') // "BagType" → "Bag Type"
      .replace(/_/g, ' ')                 // Optional: snake_case → snake case
      .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize each word
  };
  
  export const mapColumnLabels = (columns) => {
    return columns.map(col =>
      typeof col === 'string' ? { key: col, label: autoLabel(col) } : col
    );
  };
  